import Icon from '../components/Icon';

const HeartFilled = Icon(
  'heart-filled',
  <>
    <path d="M16.5 3A5.63 5.63 0 0 0 12 5.25 5.625 5.625 0 0 0 1.875 8.625c0 6.74 9.366 12.056 9.76 12.281A.73.73 0 0 0 12 21a.7.7 0 0 0 .366-.094 29.5 29.5 0 0 0 4.828-3.525c3.272-2.943 4.931-5.887 4.931-8.756A5.625 5.625 0 0 0 16.5 3" />
  </>
);

export default HeartFilled;
